<template>
  <header class="header">
    <button v-show="showBackBtn" id="header-btn-back" class="header__btn"
      title="Voltar para o passo anterior" @click="$emit('click', $event)">
      <figure>
        <ArrowHeaderGreySvg class="icon" />
      </figure>
    </button>
    <div class="header__logo">
      <component :is="brandLogo"></component>
    </div>
    <span class="header__logo-divider" />
    <div>
      <NavLogoSvg />
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderCheckin',
  props: {
    showBackBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBrand: 'selectedBrand',
      isNav: 'global/isNav',
      navLogo: 'global/navLogo',
    }),
    brandLogo() {
      return this.selectedBrand.logo;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-start;
  padding: 24px 0px 16px;

  &::after {
    position: absolute;
    left: 0;
    content: " ";
    display: block;
    height: 49px;
    border-bottom: 1px solid rgba(22, 22, 22, 0.12);
    width: 100%;
    top: 4%;
  }

  &__btn {
    margin-right: 16px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    z-index: 2;
  }

  &__logo-divider {
    margin: 0px 16px;
    width: 1px;
    background-color: rgba(22, 22, 22, 0.12);
  }

  .icon {
    width: 12px;
  }

}

// .brand__header {
//   &__header {
//     display: flex;
//     justify-content: flex-start;
//     align-content: center;
//     align-items: center;
//     padding: 24px 0px;

//     &::after {
//       position: absolute;
//       left: 0;
//       content: " ";
//       display: block;
//       height: 49px;
//       border-bottom: 1px solid rgba(22, 22, 22, 0.12);
//       width: 100%;
//       top: 4%;
//     }
//   }

//   .header {
//     &__logo_divider {
//       height: 33px;
//       width: 1px;
//       background-color: rgba(22, 22, 22, 0.12);
//       margin-right: 16px;
//     }

//     &__logo {
//       width: fit-content;
//       max-width: 120px;
//       display: flex;
//       margin-right: 16px;
//     }

//     &__btn {
//       width: fit-content;
//       border: none;
//       background-color: transparent;
//       cursor: pointer;
//       z-index: 2;
//       margin-right: 26px;

//       .icon {
//         width: 12px;

//       }
//     }
//   }

// }
</style>
